import React, { type FC, type JSX } from 'react';
import { useCommonClient } from '@/app/common/commonClientProvider.tsx';
import { Icon } from '@/app/common/icons/Icon';
import { ArrowCircle, ArrowContainer } from './styled';

type ArrowProps = {
  isRightArrow?: boolean;
  handleArrowClick: (val: string) => void;
  noShadow?: boolean;
  evo?: boolean;
  pointerOnly?: boolean;
  'aria-label'?: string;
};

const Arrow: FC<ArrowProps> = ({
  isRightArrow,
  handleArrowClick,
  noShadow,
  evo,
  pointerOnly,
  'aria-label': ariaLabel,
}): JSX.Element => {
  const { externalHeaderEnabled } = useCommonClient();

  return (
    <ArrowContainer isRightArrow={isRightArrow} externalHeaderEnabled={externalHeaderEnabled} $evo={evo}>
      <ArrowCircle
        noShadow={noShadow}
        $evo={evo}
        aria-label={ariaLabel}
        aria-hidden={pointerOnly || undefined}
        tabIndex={pointerOnly ? -1 : undefined}
        onClick={() => handleArrowClick(isRightArrow ? 'right' : 'left')}
      >
        <Icon
          category="Arrows"
          name={isRightArrow ? 'icon-small-chevron-right' : 'icon-small-chevron-left'}
          size={20}
          color="iconPrimary"
          alt={isRightArrow ? 'right' : 'left'}
        />
      </ArrowCircle>
    </ArrowContainer>
  );
};

export default Arrow;
